import Vue from 'vue'
import i18n from '../../helpers/i18nHelpers'
import { parse, format } from 'libphonenumber-js'
import store from '../store'
import VueCookies from 'vue-cookies'
import axios from 'axios'
import userEventLogHelpers from '../../helpers/userEventLogHelpers'

const state = {
  isFetching: false,
  isAdding: false,
  isAddingOrder: false,
  isChecking: false,
  availability: false,
  preBookingData: null,
  preCheckoutData: null,
  professionals: null,
  selectedProfessional: null,
  userPlaces: null,
  userPlaceCities: null,
  userPlaceSizes: null,
  totalPrice: null,
  isAddedUserPlace: false,
  acceptTermsConditions: true,
  acceptExtraHelper: true,
  newOrderData: null,
  newBookingId: null,
  chatRoomId: null,
  currentStep: 1,
  bookingFrom: null,
  addOrderSuccess: null,
  failureCode: null,
  provinceDiscounts: null,
  bookCleanerFormData: null,
  hoverProfessionalId: null,
  availableTodayProfessionals: null,
  nextAvailableData: {
    time: '',
    professionals: 0
  },
  availableService: null,
  limit: 20,
  isMore: true,
  tmpBookingData: null,
  tmpPreCheckoutData: null,
  errorMessage: null,
  customerAreaPhotos: []
}

const actions = {
  LOAD_PROFESSIONAL_LIST: async ({commit}, submitData) => {
    commit('REQUEST_PROFESSIONAL_LIST')
    const url = 'professionals'
    const { data } = await axios.get(url, {params: submitData})
    if (!data.error) {
      (submitData.page > 0) ? commit('ADD_PROFESSIONAL_LIST', data.professionals) : commit('SET_PROFESSIONAL_LIST', data.professionals)
      if (submitData.page === 0 && data.professionals.length && data.professionals[0].service_cost) {
        const costData = {
          totalPrice: data.professionals[0].service_cost
        }
        commit('SET_BOOKING_COST', costData)
      }
    } else {
      commit('SET_NO_DATA')
      if (submitData.page === 0) {
        commit('SET_PROFESSIONAL_LIST', [])
      }
      const nextAvailableData = {
        time: data.next_available_time,
        professionals: data.next_available_professionals
      }
      commit('SET_NEXT_AVAILABLE_DATA', nextAvailableData)
    }
  },
  LOAD_USER_PLACE_LIST: async ({commit}, queryData) => {
    const url = 'bookings'
    const { data } = await axios.get(url, { params: queryData })
    if (data) {
      commit('SET_PROVINCE_DISCOUNT_DATA', data.province_discounts)
      if (!data.error && (data.user_places && data.user_places.length > 0)) {
        const userPlaceData = {
          userPlaces: data.user_places,
          userPlaceCities: {},
          userPlaceSizes: {},
          userPlaceWorkHours: {}
        }
        // Set use place data
        const baseUserPlaces = data.user_places || []
        baseUserPlaces.forEach(userPlace => {
          if (userPlace && userPlace.id != null) {
            const keyId = String(userPlace.id)
            userPlaceData.userPlaceCities[keyId] = Number(userPlace.province_id)
            userPlaceData.userPlaceSizes[keyId] = Number(userPlace.place_size_id)
            userPlaceData.userPlaceWorkHours[keyId] = userPlace.work_hour || null
          }
        })
        commit('SET_USER_PLACE_DATA', userPlaceData)
      } else {
        commit('SET_USER_PLACE_DATA', null)
      }
    }
  },
  LOAD_PRE_CHECKOUT_DATA: async ({commit}, submitData) => {
    commit('SET_ADDED_USER_PLACE', false)
    if (submitData.user_place_id) {
      commit('SET_ADDED_USER_PLACE', true)
    }
    const url = 'bookings/pre-checkout-v2'
    const {data} = await axios.post(url, submitData)
    if (!data.error) {
      // console.log('check pre checkout data', data)
      const preCheckoutData = {
        name: data.name,
        tel: data.tel,
        omise_customer_id: null,
        last_digits: data.last_digits,
        first_time_promo_code_usage: data.first_time_promo_code_usage,
        address: data.address,
        latitude: data.latitude,
        longitude: data.longitude,
        remark: data.remark,
        pet_remark: data.pet_remark,
        place_type_id: 1,
        user_place: data.user_place,
        user_company: data.user_company,
        extras: data.extras,
        grouped_extras: data.grouped_extras,
        wallet: data.wallet,
        province_id: data.province_id,
        total_credits: data.total_credits,
        is_credit: false,
        allow_covid_selection: data.allow_covid_selection,
        allow_photo_attachment: data.allow_photo_attachment,
        allow_remark: data.allow_remark,
        require_vaccinated_professional: 0,
        payment_method: null,
        parent_service_id: data.parent_service_id
      }
      // Check user place
      if (!data.user_place) {
        preCheckoutData.user_place = {
          place_size_id: null,
          has_pet: null,
          pet_remark: null,
          user_place_pet_types: []
        }
      }
      // Check tel
      if (preCheckoutData.tel && preCheckoutData.tel.substring(0, 1) === '0') {
        const parsed = parse(preCheckoutData.tel, 'TH')
        const phone = format(parsed.phone, 'TH', 'International')
        preCheckoutData.tel = phone.replace(/ /g, '')
      }
      // Check pre-checkout data
      if (data.user_place && data.user_place.place_type_id > 0) {
        preCheckoutData.place_type_id = data.user_place.place_type_id
      }
      commit('SET_BOOKING_COST', { totalPrice: data.total_price })
      commit('SET_PRE_CHECKOUT_DATA', preCheckoutData)
    } else {
      this.$swal({text: data.message, type: 'error'})
    }
  },
  ADD_USER_PLACE: ({commit}, submitData) => {
    commit('REQUEST_ADDING_USER_PLACE')
    const url = 'users-places'
    Vue.http.post(url, submitData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('FINISH_ADDING_USER_PLACE')
        if (!response.error) {
          commit('SET_ADDED_USER_PLACE', true)
          // Update preBookingData user_place_id
          const data = {key: 'user_place_id', value: response.id}
          commit('UPDATE_PRE_BOOKING_DATA', data)
          commit('UPDATE_PRE_CHECKOUT_DATA', {key: 'user_place', value: response.user_place})
        } else {
          alert(response.message)
        }
      })
  },
  ADD_ORDER: async ({commit}, submitData) => {
    commit('SET_IS_ADDING_ORDER', true)
    const url = 'orders'
    const { data } = await axios.post(url, submitData)
    commit('SET_IS_ADDING_ORDER', false)
    let result = {
      successStatus: false,
      failureCode: data.failure_code
    }
    let newOrderData = null
    if (!data.error) {
      result.successStatus = true
      // Save user event log
      userEventLogHelpers.logEvent('purchase', {
        order_id: data.id
      })
      newOrderData = {
        id: data.id,
        orderCode: data.order_code,
        paidStatus: data.paid_status,
        chatRoomId: data.chat_room_id,
        success: result.successStatus,
        isInstantBooking: data.is_instant_booking,
        authorizeUri: null,
        selectedProfessional: null
      }
      if (submitData.payment_method !== 'credit_card') {
        newOrderData.authorizeUri = data.authorize_uri
      }
      // Track Line Event
      let isFromLine = VueCookies.get('isFromLine')
      if (isFromLine) {
        Vue.prototype.$lineTrack('Booking')
      }
    } else {
      console.error('ERROR ', data)
      commit('SET_FAILURE_CODE', data)
      if (data.failure_code && data.failure_code === 'insufficient_credit') {
        const totalCredits = data.total_credits
        // Switch off using coins
        commit('UPDATE_PRE_CHECKOUT_DATA', {key: 'is_credit', value: false})
        // Update current total available credits in preCheckoutData
        commit('UPDATE_PRE_CHECKOUT_DATA', {key: 'total_credits', value: totalCredits})
        // Update current total available credits in user
        store.commit('auth/UPDATE_USER_DATA', {key: 'totalCredits', value: totalCredits})
      }
    }
    // Set new order data
    commit('SET_NEW_ORDER_DATA', newOrderData)
  },
  ADD_SUBSCRIPTION: async ({commit}, submitData) => {
    commit('SET_IS_ADDING_ORDER', true)
    const url = 'subscriptions'
    const { data } = await axios.post(url, submitData)
    commit('SET_IS_ADDING_ORDER', false)
    let newOrderData = null
    if (!data.error) {
      // Save user event log
      userEventLogHelpers.logEvent('purchase', {
        order_id: data.order.id,
        subscription_id: data.subscription.id
      })
      const order = data.order
      newOrderData = {
        id: order.id,
        orderCode: order.order_code,
        chatRoomId: 0,
        success: true,
        isInstantBooking: false,
        authorizeUri: data.authorize_uri,
        selectedProfessional: null,
        paidStatus: order.paid_status
      }
      if (data.orders) {
        newOrderData.orderQty = data.orders.length
      }
    } else {
      // Case errors: expired coins or promo code
      commit('SET_FAILURE_CODE', data)
      if (data.failure_code && data.failure_code === 'insufficient_credit') {
        const totalCredits = data.total_credits
        // Switch off using coins
        commit('UPDATE_PRE_CHECKOUT_DATA', {key: 'is_credit', value: false})
        // Update current total available credits in preCheckoutData
        commit('UPDATE_PRE_CHECKOUT_DATA', {key: 'total_credits', value: totalCredits})
        // Update current total available credits in user
        store.commit('auth/UPDATE_USER_DATA', {key: 'totalCredits', value: totalCredits})
      }
    }
    // Set new order data
    commit('SET_NEW_ORDER_DATA', newOrderData)
  },
  ADD_PACKAGE: async ({commit}, submitData) => {
    commit('SET_IS_ADDING_ORDER', true)
    const url = 'packages'
    const { data } = await axios.post(url, submitData)
    commit('SET_IS_ADDING_ORDER', false)
    let newOrderData = null
    if (!data.error) {
      // Save user event log
      userEventLogHelpers.logEvent('purchase', {
        order_id: data.order.id,
        package_id: submitData.package_type_id
      })
      const order = data.order
      newOrderData = {
        id: order.id,
        orderCode: order.order_code,
        chatRoomId: 0,
        success: true,
        isInstantBooking: false,
        authorizeUri: data.authorize_uri,
        selectedProfessional: null,
        paidStatus: order.paid_status
      }
      if (data.orders) {
        newOrderData.orderQty = data.orders.length
      }
    } else {
      // Case errors: expired coins or promo code
      commit('SET_FAILURE_CODE', data)
      if (data.failure_code && data.failure_code === 'insufficient_credit') {
        const totalCredits = data.total_credits
        // Switch off using coins
        commit('UPDATE_PRE_CHECKOUT_DATA', {key: 'is_credit', value: false})
        // Update current total available credits in preCheckoutData
        commit('UPDATE_PRE_CHECKOUT_DATA', {key: 'total_credits', value: totalCredits})
        // Update current total available credits in user
        store.commit('auth/UPDATE_USER_DATA', {key: 'totalCredits', value: totalCredits})
      }
    }
    // Set new order data
    commit('SET_NEW_ORDER_DATA', newOrderData)
  },
  CHECK_PROFESSIONAL_AVAILABLE: ({commit}, submitData) => {
    commit('SET_CHECKING_PROFESSIONAL_AVAILABLE', true)
    commit('SET_PROFESSIONAL_AVAILABLE', false)
    const url = 'professionals/check-available'
    Vue.http.post(url, submitData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('SET_CHECKING_PROFESSIONAL_AVAILABLE', false)
        if (!response.error) {
          commit('SET_PROFESSIONAL_AVAILABLE', true)
          const costData = {
            totalPrice: response.total_price
          }
          commit('SET_BOOKING_COST', costData)
        } else {
          let errorMessage = null
          switch (response.error_case) {
            case 'BOOKING_OVERTIME':
              errorMessage = i18n.t('message.alert.overtime_booking_duration')
              break
            case 'BOOKING_OVERLAP':
              errorMessage = i18n.t('message.alert.overlapped_booking_duration')
              break
            case 'PRE_BOOKING_OVERLAP':
              errorMessage = i18n.t('message.alert.overlapped_pre_booking_duration')
              break
            case 'BOTH_BOOKING_OVERLAP':
              errorMessage = i18n.t('message.alert.overlapped_booking_duration')
              break
            case 'SELF_BOOKING_OVERLAP':
              errorMessage = i18n.t('message.alert.overlapped_booking_duration')
              break
          }
          alert(errorMessage)
        }
      })
  },
  SAVE_NO_CLEANER_EVENT: ({commit}, submitData) => {
    const url = 'bookings/save-no-professional-log'
    Vue.http.post(url, submitData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          console.log(response)
        }
      })
  },
  LOAD_TODAY_PROFESSIONALS: ({commit}, provinceId) => {
    commit('SET_TODAY_PROFESSIONALS', null)
    const url = 'bookings/today-professionals/' + provinceId
    Vue.http.get(url)
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          commit('SET_TODAY_PROFESSIONALS', response.today_professional_qty)
        }
      })
  },
  CHECK_AVAILABLE_SERVICE: ({commit}, submitData) => {
    const url = 'bookings/check-available-service'
    Vue.http.post(url, submitData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          commit('SET_AVAILABLE_SERVICE', response.available_service)
        }
      })
  }
}

const mutations = {
  SET_ADDING_STATUS: (state, status) => {
    state.isAdding = status
  },
  REQUEST_PROFESSIONAL_LIST: (state) => {
    state.isFetching = true
  },
  SET_PRE_BOOKING_DATA: (state, preBookingData) => {
    state.preBookingData = preBookingData
  },
  UPDATE_PRE_BOOKING_DATA: (state, data) => {
    state.preBookingData[data.key] = data.value
  },
  UPDATE_PRE_BOOKING_ARRAY_DATA: (state, data) => {
    if (state.preBookingData === null) {
      state.preBookingData = {}
    }

    for (let key in data) {
      state.preBookingData[key] = data[key]
    }
  },
  UPDATE_TOTAL_PRICE: (state, value) => {
    if (typeof value !== 'number') {
      value = Number(value)
    }
    state.totalPrice = value
  },
  SET_NO_DATA: (state) => {
    state.isMore = false
  },
  SET_PROFESSIONAL_LIST: (state, professionals) => {
    state.isFetching = false
    state.professionals = professionals
    state.isMore = true
    if (professionals && professionals.length < state.limit) {
      state.isMore = false
    }
  },
  ADD_PROFESSIONAL_LIST: (state, professionals) => {
    state.isFetching = false
    state.isMore = true
    for (let key in professionals) {
      state.professionals.push(professionals[key])
    }
    if (professionals && professionals.length < state.limit) {
      state.isMore = false
    }
  },
  SET_SELECTED_PROFESSIONAL: (state, selectedProfessional) => {
    state.selectedProfessional = selectedProfessional
    // state.selectedProfessional = {...state.selectedProfessional}
  },
  SET_USER_PLACE_DATA: (state, data) => {
    if (data) {
      state.userPlaces = data.userPlaces
      state.userPlaceCities = data.userPlaceCities
      state.userPlaceSizes = data.userPlaceSizes
      state.userPlaceWorkHours = data.userPlaceWorkHours
    } else {
      state.userPlaces = null
      state.userPlaceCities = null
      state.userPlaceSizes = null
      state.userPlaceWorkHours = null
    }
  },
  SET_BOOKING_COST: (state, data) => {
    state.totalPrice = data.totalPrice
  },
  SET_PRE_CHECKOUT_DATA: (state, preCheckoutData) => {
    state.preCheckoutData = preCheckoutData
  },
  UPDATE_PRE_CHECKOUT_DATA: (state, data) => {
    state.preCheckoutData[data.key] = data.value
  },
  REQUEST_ADDING_USER_PLACE: (state) => {
    state.isAdding = true
  },
  FINISH_ADDING_USER_PLACE: (state) => {
    state.isAdding = false
  },
  SET_ADDED_USER_PLACE: (state, status) => {
    state.isAddedUserPlace = status
  },
  SET_ACCEPT_TERMS_CONDITIONS: (state, status) => {
    state.acceptTermsConditions = status
  },
  SET_EXTRA_HELPER: (state, status) => {
    state.acceptExtraHelper = status
  },
  SET_IS_ADDING_ORDER: (state, status) => {
    state.isAddingOrder = status
  },
  SET_NEW_ORDER_DATA: (state, data) => {
    if (data) {
      state.newOrderData = data
      state.newOrderData.selectedProfessional = state.selectedProfessional
    } else {
      state.newOrderData = data
    }
  },
  SET_BOOKING_CURRENT_STEP: (state, currentStep) => {
    state.currentStep = currentStep
  },
  SET_CHECKING_PROFESSIONAL_AVAILABLE: (state, status) => {
    state.isChecking = status
  },
  SET_PROFESSIONAL_AVAILABLE: (state, status) => {
    state.availability = status
  },
  SET_BOOKING_FROM: (state, bookingFrom) => {
    state.bookingFrom = bookingFrom
  },
  SET_FAILURE_CODE: (state, response) => {
    state.errorMessage = response.message
    state.failureCode = response.failure_code
  },
  SET_PROVINCE_DISCOUNT_DATA: (state, provinceDiscounts) => {
    let discounts = {}
    for (let key in provinceDiscounts) {
      let index = provinceDiscounts[key].work_hour.toString()
      let value = provinceDiscounts[key].discount
      discounts[index] = value
    }
    state.provinceDiscounts = discounts
  },
  SET_BOOK_CLEANER_FORM: (state, data) => {
    state.bookCleanerFormData = data
  },
  SET_HOVER_PROFESSIONAL_ID: (state, data) => {
    state.hoverProfessionalId = data
  },
  UPDATE_FAVORITE_PROFESSIONAL: (state, data) => {
    const professionalId = data.professional_id
    const isFavoritedProfessional = data.is_favorited_professional
    for (let key in state.professionals) {
      const professional = state.professionals[key]
      if (professional.id === professionalId) {
        state.professionals[key].is_favorited_professional = isFavoritedProfessional
      }
    }
  },
  SET_TODAY_PROFESSIONALS: (state, num) => {
    state.availableTodayProfessionals = (num > 0) ? num : null
  },
  SET_NEXT_AVAILABLE_DATA: (state, data) => {
    state.nextAvailableData = data
  },
  SET_AVAILABLE_SERVICE: (state, data) => {
    state.availableService = data
  },
  SET_TMP_BOOKING_DATA: (state, data) => {
    state.tmpBookingData = data
  },
  SET_TMP_PRE_CHECKOUT_DATA: (state, data) => {
    state.tmpPreCheckoutData = data
  },
  ADD_CUSTOMER_AREA_PHOTO: (state, imageUrl) => {
    state.customerAreaPhotos.push(imageUrl)
  },
  DELETE_CUSTOMER_AREA_PHOTO: (state, imageUrl) => {
    for (let key in state.customerAreaPhotos) {
      if (state.customerAreaPhotos[key] === imageUrl) {
        state.customerAreaPhotos.splice(key, 1)
        break
      }
    }
  },
  CLEAR_CUSTOMER_AREA_PHOTOS: (state) => {
    state.customerAreaPhotos = []
  }
}

const getters = {
  getState: state => {
    return state
  },
  getPreBookingData: state => {
    return state.preBookingData
  },
  getPreCheckoutData: state => {
    return state.preCheckoutData
  },
  getProfessionals: state => {
    return state.professionals
  },
  getSelectedProfessional: state => {
    return state.selectedProfessional
  },
  getIsChecking: state => {
    return state.isChecking
  },
  isAdding: state => {
    return state.isAdding ? 'message.button.loading' : 'message.button.submit'
  },
  isAddingUserPlace: state => {
    return state.isAdding ? 'message.button.loading' : 'message.button.continue'
  },
  isAddingOrder: state => {
    return state.isAddingOrder ? 'message.button.loading' : 'message.button.submit_booking'
  },
  getNewOrderData: state => {
    return state.newOrderData
  },
  getIsCheckingText: state => {
    return state.isChecking ? 'message.button.loading' : 'message.button.book'
  },
  getIsCheckingInstantBook: state => {
    return state.isChecking ? 'message.button.loading' : 'message.button.instant_book'
  },
  getProvinceDiscounts: state => {
    return state.provinceDiscounts
  },
  getHoverProfessionalId: state => {
    return state.hoverProfessionalId
  },
  getAvailableTodayProfessionals: state => {
    return state.availableTodayProfessionals
  },
  isLoadMore: state => {
    return state.isFetching ? 'message.button.loading' : 'message.button.load_more'
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/booking.js